import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

export default function UsersCreateAgent() {
  const theme = useTheme();
  const { t } = useTranslation();

  return <div>Cadastro</div>;
}
